import Axios from "axios";
import ApiError from "./ApiError";
import ERRORS from "./errorConstants";
import { message } from "antd";
import { apiURL } from "../views/service/service-url";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../views/common/notification-message/notification";

const setupInterceptors = (store) => {
  // Default settings for Axios request
  Axios.defaults.baseURL = apiURL;
  Axios.defaults.headers.post["Content-Type"] = "application/json";
  Axios.defaults.validateStatus = () => true;
  Axios.interceptors.request.use(
    (config) => {
      if (config.data) {
        config.data.applicationId = 1;
      }
      const token = localStorage.getItem("access_token");

      if (token) {
        const access_token = token;
        config.headers.Authorization = `Bearer ${access_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  Axios.interceptors.response.use(
    (response) => {
      // Process response body
      if (response.status && parseInt(response.status, 0) > 205) {
        const resMessage = response.data
          ? typeof response.data === "object"
            ? response.data.Message
            : response.data
          : "Something went wrong";
        switch (response.status) {
          case 500:
            // message.error("Something went wrong");
            openNotificationWithIcon(notificationStrings.error, resMessage);
            throw new ApiError(ERRORS.SERVER_ERROR);
          case 401:
            message.error("Unauthorized");
            localStorage.clear();
            sessionStorage.clear();
            throw new ApiError(
              ERRORS.UNAUTHORISED_ERROR,
              response.data.error.message
            );
          case 403:
            message.error("Unauthorized");
            localStorage.clear();
            sessionStorage.clear();
            throw new ApiError(
              ERRORS.FORBIDDEN_ERROR,
              response && response.data && response.data.Message
                ? response.data.Message
                : "Network Error"
            );
          case 406:
            message.error(resMessage);
            throw new ApiError(
              ERRORS.UNAUTHORISED_ERROR,
              response.data.error.message
            );
          case 400:
            openNotificationWithIcon(notificationStrings.error, resMessage);
            throw new ApiError(ERRORS.UNAUTHORISED_ERROR, response.data);
          case 404:
            message.error(resMessage);

            throw new ApiError(ERRORS.CLIENT_ERROR);
          default:
            // message.error(resMessage);
            throw new ApiError({
              name: "",
              message: resMessage,
            });
        }
      } else {
        return response;
      }
    },
    (error) => Promise.reject(error)
  );
};

/**
 * Set auth token as default in Axios
 * @param token
 */
export const setAuthToken = (token = localStorage.getItem("access_token")) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
    "access_token"
  )}`;
};
export default setupInterceptors;
